import { Grid } from "@mui/material";
import { useEffect, useReducer, useState } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import PrintQueryControlService from "./PrintQueryControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from '../../componentes/chip/DefaultChip';
import { Typography } from "@material-ui/core";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import DefaultButton from "../../componentes/button/DefaultButton";
import { FaRegEdit } from "react-icons/fa";
/**
 * Author : GustavoHS
 * 09/12/2026
*/

export const PrintQueryGeneric = () => {

	const { t } = useTranslation();
	const { control } = useForm();
	const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);
	const userId = sessionStorage.getItem("userId");
	const loggedRole = Number(sessionStorage.getItem("role") || 0);
	const initialState = {
		id: 0,
		idClient: loggedIdClient,
		rows: [],
		printDateEnd: null,
		printDateStart: null,
		printDate: null,
		idProduct: 0,
		productName: "",
		batch: "",
		printStatus: 2,
		userId: Number(userId) ?? 0,
		success: false,
		error: false,
	};

	const columnsPrintQuery = (t, handleReprint) => [
		{ field: "id", flex: 0.5, visible: false },
		{
			field: "idPrint",
			textAlign: 'center',
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="ids" name="id" />;
			},
			template: (props) => {
				return (
					<>
						<DefaultChip
							style="standard"
							label={<Typography
								variant="body3"
								style={{ whiteSpace: 'normal' }}>{props.idPrint}
							</Typography>}
						/>
					</>
				)
			}
		},
		{
			field: "productName",
			textAlign: "center",
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="productName" name="company" />;
			},
			template: (props) => {
				return (
					<>
						<DefaultChip
							style="grey"
							label={<Typography
								variant="body3"
								style={{ whiteSpace: 'normal' }}>{props.productName}
							</Typography>}
						/>
					</>
				)
			}
		},
		{
			field: "clientName",
			textAlign: "center",
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="clientName" name="company" />;
			},
			template: (props) => {
				return (
					<>
						<DefaultChip
							style="grey"
							label={<Typography
								variant="body3"
								style={{ whiteSpace: 'normal' }}>{props.clientName}
							</Typography>}
						/>
					</>
				)
			}
		},
		{
			field: "printQuantity",
			textAlign: "center",
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="printQuantity" name="company" />;
			},
			template: (props) => {
				return (
					<>
						<DefaultChip
							style="grey"
							label={<Typography
								variant="body3"
								style={{ whiteSpace: 'normal' }}>{props.printQuantity}
							</Typography>}
						/>
					</>
				)
			}
		},
		{
			field: "printDate",
			textAlign: "center",
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="printDate" name="printDate" />;
			},
			flex: 1,
			template: (props) => {
				return (
					<>
						{props.printDate ?
							<DefaultChip
								style="gray"
								label={<Typography
									variant="body3"
									style={{ whiteSpace: 'normal' }}>{props.printDate}
								</Typography>}
							/>
							: null}
					</>
				)
			}
		},
		{
			field: "printStatus",
			textAlign: "center",
			headerTemplate: () => {
				return <IconLabelSwitch isHeader={true} labelName="status" />;
			},
			flex: 0.5,
			template: (props) => {
				return (
					<>
						{props.printStatus ? (
							<IconSwitch name="active" />
						) : (
							<IconSwitch name="canceled" />
						)}
					</>
				);
			},
		},
		...(loggedRole !== 2
			? [
				{
					field: "",
					headerText: "Reimprimir",
					textAlign: 'center',
					template: (row) => {

						const baseStyle = {
							cursor: "pointer",
							transition: "all 0.3s ease",
							border: "2px solid transparent",
							borderRadius: "8px",
							padding: "5px"
						};

						const hoverStyle = {
							borderColor: "#000000",
							backgroundColor: "rgba(0, 123, 255, 0.1)",
							transform: "scale(1.05)",
						};

						const activeStyle = {
							transform: "scale(0.95)",
							backgroundColor: "rgba(0, 123, 255, 0.2)",
						};

						return (
							<FaRegEdit
								size={20}
								color="#ff1100"
								onClick={() => handleReprint(row.idPrint)}
								onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
								onMouseLeave={e => Object.assign(e.currentTarget.style, baseStyle)}
								onMouseDown={e => Object.assign(e.currentTarget.style, activeStyle)}
								onMouseUp={e => Object.assign(e.currentTarget.style, hoverStyle)}
								style={baseStyle}
							/>
						);
					}
				}
			]
			: []),
	];

	const reducer = (state, action) => {
		switch (action.type) {
			case 'update':
				return { ...state, ...action.data }
			case "clear":
				return { ...initialState, idClient: state.idClient }
			case 'success':
				return { ...state, success: true, error: false }
			case 'error':
				return { ...state, success: false, error: true }
			case 'close_alert':
				return { ...state, success: false, error: false }
			default:
				return new Error();
		}
	}

	const [state, dispatch] = useReducer(reducer, initialState);

	const handleReprint = (idPrint) => {

		const request = { ...state, idPrint: idPrint }

		PrintQueryControlService
			.updatePrintQueryGeneric(request)
			.then(() => {
				const searchRequest = {
					...request,
					printDateStart: state.printDateStart ? formatDateToSearch(state.printDateStart) : '',
					printDateEnd: state.printDateEnd ? formatDateToSearch(state.printDateEnd) : ''
				};

				PrintQueryControlService
					.getPrintQueryGeneric(searchRequest)
					.then((response) => {
						const data = response.data.map(row => {
							return {
								...row,
								printDate: formatDateToGrid(row.printDate)
							};
						});
						dispatch({ type: "update", data: { rows: data } });
					});
			})
	}

	const handleChange = (event) => {
		const { name, value, valueComplete } = event.target;

		if (name === "productName") {

			if (!value) {
				dispatch({
					type: 'update',
					data: {
						productName: "",
						idProduct: 0
					}
				});
				return;
			}

			dispatch({
				type: 'update',
				data: {
					productName: valueComplete.name,
					idProduct: value
				}
			});
			return;
		}
		dispatch({ type: "update", data: { [name]: value } });
	};

	const formatDateToSearch = (date) => {
		return new Date(date).toLocaleDateString("sv-SE");
	};

	// const formatDateToGrid = (date) => {
	// 	if (!date) return " "
	// 	const dateParts = new Date(date).toLocaleDateString("sv-SE").split("-");
	// 	return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
	// };

	const formatDateToGrid = (date) => {
		if (!date) return "";
		return date.split(" ")[0];
	};
	const handleSearch = () => {

		const request = { ...state }

		request.printDateStart = state.printDateStart ? formatDateToSearch(state.printDateStart) : ''
		request.printDateEnd = state.printDateEnd ? formatDateToSearch(state.printDateEnd) : ''
		PrintQueryControlService
			.getPrintQueryGeneric(request)
			.then((response) => {
				if (response.status === 200) {
					const data = response.data.map(row => {
						return {
							...row,
							printDate: formatDateToGrid(row.printDate)
						};
					});
					dispatch({ type: 'update', data: { rows: data } })
				}
			})
			.catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
	}

	useEffect(() => {
		handleSearch();
	}, [])

	return (
		<>
			<DefaultScreenAccordion
				title={"printQuery"}
				isRegister
				fields={
					<GridItemContainer>
						<CustomAlert
							success={state.success}
							error={state.error}
							handleCloseAlert={() => dispatch({ type: 'close_alert' })}
						/>
						<Grid item xs={12} sm={6} md={4}>
							<div style={{
								pointerEvents: loggedIdClient !== 0 ? "none" : "auto",
								opacity: loggedIdClient !== 0 ? 0.8 : 1
							}}>
								<DefaultAutocomplete
									iconLabelSwitch={
										<IconLabelSwitch
											name={loggedIdClient !== 0 ? "unLock" : "user"}
											labelName="client"
										/>
									}
									name="idClient"
									onChange={loggedIdClient !== 0 ? undefined : handleChange}
									disabled={loggedIdClient !== 0}
									value={state.idClient}
									defaultSize
									useApi
									endpoint='GetClientGeneric'
									error={state.error && !state.idClient}

								/>
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={12}>
							<GridInputRow>

								<Grid item xs={12} sm={6} md={4}>
									<InputField
										name="batch"
										control={control}
										defaultValue=""
										onChange={handleChange}
										value={state.batch}
										inputProps={{ maxLength: 50 }}
										error={state.error && state.batch === ""}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4}>
									<DefaultAutocomplete
										iconLabelSwitch={
											<IconLabelSwitch name="productName" labelName="productName" />
										}
										onChange={handleChange}
										name="productName"
										value={state.idProduct}
										defaultSize
										useApi
										endpoint='GetProductGeneric'
										error={state.error && state.idProduct === ''}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4}>
									<DefaultAutocomplete
										name={"printStatus"}
										onChange={handleChange}
										value={state.printStatus}
										label={t("status")}
										defaultSize
										items={[
											{ id: 2, name: t("select"), status: 1 },
											{ id: 0, name: t("noPrinted"), status: 1 },
											{ id: 1, name: t("printed"), status: 1 }
										]}
										error={state.error}
									/>
								</Grid>

							</GridInputRow>
							<GridInputRow>
								<Grid item xs={12} sm={6} md={3}>
									<CustomDatePicker
										id="printDateStart"
										name="printDateStart"
										defaultValue=""
										selectedDate={state.printDateStart}
										handleChange={handleChange}
										error={state.error && state.printDateStart === null}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={3}>
									<CustomDatePicker
										id="printDateEnd"
										name="printDateEnd"
										defaultValue=""
										selectedDate={state.printDateEnd}
										handleChange={handleChange}
										error={state.error && state.printDateEnd === null}
									/>
								</Grid>
							</GridInputRow>
						</Grid>

						<SearchClearSaveRow
							onClickSearch={handleSearch}
							onClickClear={() => dispatch({ type: 'clear' })}
						/>
						{(state.rows.length > 0) ? (
							<GridInputRow>
								<Grid item xs={12}>
									<DefaultDatagrid
										columns={columnsPrintQuery(t, handleReprint)}
										dataSource={state.rows}
										allowPaging={true}
									/>
								</Grid>
							</GridInputRow>
						) : null}
					</GridItemContainer>
				} />
		</>
	);
}